export class Controller {

    /** @ngInject */
    constructor($state, $stateParams, LicenseManagementService, OkModal, Alert) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.LicenseManagementService = LicenseManagementService;
        this.OkModal = OkModal;
        this.Alert = Alert;
    }

    $onInit() {
        this.licenseInfo = this.licenseDetails.licenseInfo;
        this.currentPlan = this.licenseDetails.companyLicensePlan;
        this.selectedTier = this.licenseTiers[0];
        this.selectedPrice = this.selectedTier.prices[0];

        // if(this.licenseInfo.licenseStatus != 'LICENSED') {
        //     this.$state.go('company.license-management.current-plan');
        // }
    }

    calculate() {
        let purchaseDTO = {
            userSeats: this.seats,
            promotionCode: this.promotionCode,
        }
        this.LicenseManagementService.calculateLicenseCharges(this.$stateParams.companyId, purchaseDTO)
        .then(data => {
            this.calculatedCharges = data;
        })
    }

    purchase() {
        let purchaseDTO = {
            // tierId: this.selectedTier.tierId,
            // priceId: this.selectedPrice.priceId,
            userSeats: this.seats,
            promotionCode: this.promotionCode,
            // email: this.email
        }
        this.LicenseManagementService.upgradeLicense(this.$stateParams.companyId, purchaseDTO)
        .then(result => {
            if(result.checkoutError) {
                this.Alert('danger', result.checkoutError);
            } else {
                this.$state.reload('company.license-management');
                let message = `Your purchase request has been successfully sent. 
                    If your payment method was not saved during your license subscription, 
                    you will receive an open invoice to email: ${this.currentPlan.licensingActivitiesEmailAddress || ''}.
                    <br><br> After the payment is done, subscription update will be applied on the admin portal`
                this.OkModal(message)
                    .then(() => {
                        this.$state.go('^');
                    });
                    
            }
        })
        .catch((error) => {
            if(error.data.serviceErrorCode === 'ERR_111102') {
                let message = `${error.data.message}
                    <br><br><a class="btn sp_small-primary-button" target="_blank" href="${error.data.more}">Add Payment Method</a>`
                this.OkModal(message)
                    .then(() => {
                    });
            }
        });
    }

    subscribeButtonDisabled() {
        return !this.seats || this.seats <= 0 || this.licenseDetails.waitingActivity;
    }
    
    cancelWaitingActivity() {
        this.LicenseManagementService.cancelWaitingActivity(this.$stateParams.companyId)
            .then(()=> {
                this.Alert('success', 'global.messages.operation-successful');
                this.$state.reload('company.license-management');
            })      
    }

}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/seat/add-seat.controller.js